<section class="main-section">
  <header
    class="d-flex justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center px-0">
      <a
        class="btn btn-link me-3 p-0 d-block d-xl-none"
        data-bs-toggle="offcanvas"
        href="#offcanvasExample"
        role="button"
        aria-controls="offcanvasExample"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 7H21"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M3 12H21"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M3 17H21"
            stroke="#292D32"
            stroke-width="1.5"
            stroke-linecap="round"/></svg></a>

      <h3 class="heading-span">School Details</h3>
     </div>
  </header>
    <div class="bg-white radius8 school-basic-details school-grid-container w-100 mx-0 p-4 me-0">
      <div *ngIf="school.schoolName" class="school-details p-4 mx-0">
        <div class="d-flex w-100 justify-content-between">
        <h3 class="heading-span my-1">Basic Details</h3>
        <button type="button" 
        (click)="editSchool(school)" class="btn theme-btn basic-detail-btn bg-transparent py-0">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_3511_126127)">
              <path
                d="M11.0504 3L4.20878 10.2417C3.95045 10.5167 3.70045 11.0583 3.65045 11.4333L3.34211 14.1333C3.23378 15.1083 3.93378 15.775 4.90045 15.6083L7.58378 15.15C7.95878 15.0833 8.48378 14.8083 8.74211 14.525L15.5838 7.28334C16.7671 6.03334 17.3004 4.60834 15.4588 2.86667C13.6254 1.14167 12.2338 1.75 11.0504 3Z"
                stroke="#5D847B"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"/>
              <path
                d="M9.9082 4.20833C10.2665 6.50833 12.1332 8.26666 14.4499 8.49999"
                stroke="#5D847B"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"/>
              <path
                d="M2.5 18.3333H17.5"
                stroke="#5D847B"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_3511_126127">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span class="ms-2">Edit</span>
        </button>
        </div>
        <div class="row mt-2">
            <div class="col-md-4">
                <span class="basic-detail-span">School Name</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.schoolName}}</p>
            </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
              <span class="basic-detail-span">School Code</span>
          </div>
          <div class="col-md-8">
              <p class="basic-detail-value">{{school.id}}</p>
          </div>
      </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">Headcount</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.headcountOfSchool}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">Teaching Staff</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.numberOfTeachingStaff}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">Non-Teaching Staff</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.numberOfNonTeachingStaff}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">Location</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.location}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">School Capacity</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.schoolCapacity}}</p>
            </div>
        </div>
        <div class="row">
          <div class="col-md-4">
              <span class="basic-detail-span">No of School Users</span>
          </div>
          <div class="col-md-8">
              <p class="basic-detail-value">{{school.numberOfSchoolUser}}</p>
          </div>
      </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">School Type</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.schoolType}}</p>
            </div>
        </div>
        <div class="row">
          <div class="col-md-4">
              <span class="basic-detail-span">Curriculum</span>
          </div>
          <div class="col-md-8">
              <p class="basic-detail-value">{{school.curriculum}}</p>
          </div>
      </div>
      <div class="row">
          <div class="col-md-4">
              <span class="basic-detail-span">Address</span>
          </div>
          <div class="col-md-8">
              <p class="basic-detail-value basic-address">{{school.address}}</p>
          </div>
      </div>
      <div class="row">
          <div class="col-md-4">
              <span class="basic-detail-span">Local Authority</span>
          </div>
          <div class="col-md-8">
              <p class="basic-detail-value">{{school.localAuthority}}</p>
          </div>
      </div>
      <div class="row">
        <div class="col-md-4">
            <span class="basic-detail-span">ID: URN/DfE Number/UKPRN</span>
        </div>
        <div class="col-md-8">
            <p class="basic-detail-value">{{school.schoolRegistrationId}}</p>
        </div>
    </div>
        <div class="row">
            <div class="col-md-4">
                <span class="basic-detail-span">Comments</span>
            </div>
            <div class="col-md-8">
                <p class="basic-detail-value">{{school.notes}}</p>
            </div>
        </div>
        </div>
      <div *ngIf="!school.schoolName" class="noDataFound">
        <h1>{{'No Data Found'}}</h1>
      </div>
    </div>  
</section>
